import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { useBrand } from "@/context/BrandContext";
import { GoogleButton } from "@/components/GoogleButton";


export default function Register() {
  const { register } = useAuth();
  const { brand, logoSrc } = useBrand();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", company_name: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      const plan = new URLSearchParams(window.location.search).get("plan");
      toast.success("Workspace created");
      nav(plan ? "/billing" : "/billing?welcome=0");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0b0f17] grid-bg p-6">
      <form onSubmit={submit} className="w-full max-w-md sc-card p-8" data-testid="register-form">
        <div className="flex items-center gap-3 mb-6">
          <img src={logoSrc} alt={brand.product_name} className="w-16 h-16 object-contain mix-blend-screen" />
          <div>
            <div className="font-heading text-lg font-extrabold"><span className="text-slate-100">STEEL</span><span className="text-amber-400">FORGE AI</span></div>
            <div className="label-cap">Create fab workspace</div>
          </div>
        </div>

        {[
          { k: "name", label: "Your name", type: "text" },
          { k: "company_name", label: "Company / workspace", type: "text" },
          { k: "email", label: "Email", type: "email" },
          { k: "password", label: "Password", type: "password" },
        ].map((f) => (
          <label className="block mb-4" key={f.k}>
            <span className="label-cap">{f.label}</span>
            <input
              type={f.type}
              required
              value={form[f.k]}
              onChange={(e) => setForm({ ...form, [f.k]: e.target.value })}
              className="mt-1 w-full bg-slate-950/60 border border-slate-800 rounded-md px-3 py-2.5 text-slate-100 focus:outline-none focus:border-amber-500"
              data-testid={`register-${f.k}-input`}
            />
          </label>
        ))}

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-amber-500 hover:bg-amber-400 text-slate-950 font-semibold py-2.5 rounded-md transition disabled:opacity-50"
          data-testid="register-submit-button"
        >
          {loading ? "Creating…" : "Create workspace"}
        </button>
        <div className="my-4 flex items-center gap-3 text-[10px] font-mono text-slate-500"><span className="flex-1 h-px bg-slate-800" />OR<span className="flex-1 h-px bg-slate-800" /></div>
        <GoogleButton label="Continue with Google" testId="google-signup-button" />
        <div className="mt-4 text-sm text-slate-400 text-center">
          Have an account?{" "}
          <Link to="/login" className="text-amber-400 hover:text-amber-300" data-testid="register-to-login-link">
            Sign in
          </Link>
        </div>
      </form>
    </div>
  );
}
